var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "success-page page-main no-shadow" }, [
    _c("div", { staticClass: "success-box text-color-black" }, [
      _c(
        "div",
        {
          staticClass: "spaceCenter",
          staticStyle: { "margin-bottom": "27px" }
        },
        [
          _c(
            "svg",
            {
              staticClass: "icon login-input-i",
              attrs: { "aria-hidden": "true" }
            },
            [
              _c("use", {
                attrs: { "xlink:href": "#gold-icon-tijiaowancheng" }
              })
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "spaceCenter text" }, [
        _vm._v("\n          " + _vm._s(_vm.text) + "\n      ")
      ])
    ]),
    _vm._v(" "),
    _vm._m(0)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "spaceCenter" }, [
      _c("div", { staticClass: "success-text" }, [
        _vm._v(
          "银行审核通过后，将向您在平台的预留手机号码发送审核结果通知，请注意查收。"
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d7448f38", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d7448f38","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/bank/bank-step-success.vue
// module id = nAa0
// module chunks = 1